import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=44b1a1f8&scoped=true&"
import script from "./Compass.vue?vue&type=script&lang=js&"
export * from "./Compass.vue?vue&type=script&lang=js&"
import style0 from "./Compass.vue?vue&type=style&index=0&id=44b1a1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b1a1f8",
  null
  
)

export default component.exports